/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * COD Quick Checkout Theme Compatibility Handler
 * Resolves theme compatibility for [data-cst-buy-now-button] across Warehouse/Vibrant theme.
 */
(function () {
  if (typeof window === "undefined") return;
  if (window.__cstCodQuickBuyInitialized) {
    if (typeof window.__cstCodSyncButtons === "function") {
      window.__cstCodSyncButtons();
    }
    return;
  }
  window.__cstCodQuickBuyInitialized = true;

  function normalizeProductGid(raw) {
    var val = String(raw || "").trim();
    if (!val) return "";
    if (val.indexOf("gid://shopify/Product/") === 0) return val;
    var matches = val.match(/\d+/);
    return matches ? "gid://shopify/Product/" + matches[0] : "";
  }

  function normalizeVariantId(raw) {
    var val = String(raw || "").trim();
    if (!val) return "";
    if (val.indexOf("gid://shopify/ProductVariant/") === 0) {
      return val.replace("gid://shopify/ProductVariant/", "").trim();
    }
    var matches = val.match(/\d+/);
    return matches ? matches[0] : val;
  }

  function normalizeImageUrl(url) {
    var img = String(url || "").trim();
    if (!img) return "";
    if (img.indexOf("//") === 0) return "https:" + img;
    return img;
  }

  function normalizePriceCents(raw) {
    if (typeof raw === "number" && !isNaN(raw)) return Math.max(0, Math.round(raw));
    var str = String(raw || "").replace(/[^0-9]/g, "");
    var val = parseInt(str, 10);
    return isNaN(val) ? 0 : Math.max(0, val);
  }

  function resolveFormVariantData(form, variantId) {
    if (!form) return null;
    var script = form.querySelector('script[data-variant]');
    if (script && script.textContent) {
      try {
        var data = JSON.parse(script.textContent);
        if (data && (!variantId || String(data.id) === String(variantId))) {
          return data;
        }
      } catch (e) {}
    }
    return null;
  }

  function syncButtonState(button) {
    if (!button || !button.getAttribute) return;

    if (!button.hasAttribute("data-buy-now-launch-mode")) {
      button.setAttribute("data-buy-now-launch-mode", "product_only");
    }
    if (!button.hasAttribute("data-cod-buy-now-launch-mode")) {
      button.setAttribute("data-cod-buy-now-launch-mode", "product_only");
    }

    var form = button.closest("form");
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    var currentVariantId = variantInput ? variantInput.value : "";
    if (currentVariantId) {
      button.setAttribute("data-variant-id", normalizeVariantId(currentVariantId));
    }

    var vData = resolveFormVariantData(form, currentVariantId);
    if (vData) {
      if (vData.title) button.setAttribute("data-variant-title", vData.title);
      if (vData.price) button.setAttribute("data-price-cents", String(vData.price));
      if (vData.featured_image && (vData.featured_image.src || vData.featured_image.url)) {
        button.setAttribute("data-product-image", normalizeImageUrl(vData.featured_image.src || vData.featured_image.url));
      } else if (vData.featured_media && vData.featured_media.preview_image && vData.featured_media.preview_image.src) {
        button.setAttribute("data-product-image", normalizeImageUrl(vData.featured_media.preview_image.src));
      }
      if (vData.available === false) {
        button.style.display = "none";
        button.setAttribute("aria-disabled", "true");
        return;
      }
    }

    var isSwatchDisabled = Boolean(
      form.querySelector(".block-swatch.block-swatch--disabled input:checked") ||
      form.querySelector(".color-swatch--disabled input:checked") ||
      form.querySelector(".variant-swatch--disabled input:checked")
    );

    if (isSwatchDisabled) {
      button.style.display = "none";
      button.setAttribute("aria-disabled", "true");
    } else {
      button.style.display = "";
      button.removeAttribute("aria-disabled");
    }
  }

  function syncAllButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll("[data-cst-buy-now-button]");
    for (var i = 0; i < buttons.length; i++) {
      syncButtonState(buttons[i]);
    }
  }

  window.__cstCodSyncButtons = syncAllButtons;

  function onBuyNowClick(event) {
    var button = event.target && event.target.closest ? event.target.closest("[data-cst-buy-now-button]") : null;
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (button.disabled || button.getAttribute("aria-disabled") === "true") {
      return;
    }

    var form = button.closest("form");

    var rawGid = button.getAttribute("data-product-gid") || "";
    if (!rawGid && form) {
      var root = button.closest("[data-product-id], [data-product-gid], [data-product]");
      rawGid = root ? (root.getAttribute("data-product-gid") || root.getAttribute("data-product-id") || "") : "";
    }
    var productGid = normalizeProductGid(rawGid);

    var formVariantInput = form ? form.querySelector('input[name="id"]') : null;
    var rawVariantId = (formVariantInput && formVariantInput.value) || button.getAttribute("data-variant-id") || "";
    var variantId = normalizeVariantId(rawVariantId);

    var vData = resolveFormVariantData(form, variantId);

    var productTitle = (button.getAttribute("data-product-title") || "").trim();
    if (!productTitle && form) {
      var titleEl = form.querySelector(".product-meta__title, h1, .product__title");
      if (titleEl) productTitle = titleEl.textContent.trim();
    }

    var variantTitle = (vData && vData.title) || (button.getAttribute("data-variant-title") || "").trim();

    var productImage = "";
    if (vData && vData.featured_image && (vData.featured_image.src || vData.featured_image.url)) {
      productImage = normalizeImageUrl(vData.featured_image.src || vData.featured_image.url);
    } else if (vData && vData.featured_media && vData.featured_media.preview_image && vData.featured_media.preview_image.src) {
      productImage = normalizeImageUrl(vData.featured_media.preview_image.src);
    } else {
      productImage = normalizeImageUrl(button.getAttribute("data-product-image") || "");
    }

    var rawPrice = (vData && vData.price) || button.getAttribute("data-price-cents") || button.getAttribute("data-product-price-cents") || "";
    var priceCents = normalizePriceCents(rawPrice);

    button.setAttribute("data-buy-now-launch-mode", "product_only");
    button.setAttribute("data-cod-buy-now-launch-mode", "product_only");
    if (productGid) button.setAttribute("data-product-gid", productGid);
    if (variantId) button.setAttribute("data-variant-id", variantId);
    if (productTitle) button.setAttribute("data-product-title", productTitle);
    if (variantTitle) button.setAttribute("data-variant-title", variantTitle);
    if (productImage) button.setAttribute("data-product-image", productImage);
    if (priceCents > 0) button.setAttribute("data-price-cents", String(priceCents));

    var blockId = (button.getAttribute("data-buy-now-block-id") || button.getAttribute("data-cod-buy-now-open") || "").trim();

    var payload = {
      productGid: productGid,
      variantId: variantId,
      productTitle: productTitle,
      variantTitle: variantTitle,
      productImage: productImage,
      priceCents: priceCents,
      launchMode: "product_only",
      blockId: blockId
    };

    var codBlock = (blockId ? document.querySelector('[data-buy-now-block="' + CSS.escape(blockId) + '"]') : null)
      || document.querySelector("[data-buy-now-block]");

    if (codBlock) {
      if (productGid) codBlock.dataset.productGid = productGid;
      if (variantId) {
        codBlock.dataset.variantGid = "gid://shopify/ProductVariant/" + variantId;
        var vf = codBlock.querySelector("[data-buy-now-variant-field]");
        if (vf) vf.value = variantId;
        var povf = codBlock.querySelector("[data-buy-now-pay-online-variant-field]");
        if (povf) povf.value = variantId;
      }
      codBlock.dispatchEvent(new CustomEvent("cst:apply-external-product", {
        detail: payload
      }));
    }

    window.dispatchEvent(new CustomEvent("cst:open-popup", {
      detail: payload
    }));
  }

  document.addEventListener("click", onBuyNowClick, true);

  function onVariantChange(event) {
    var variant = event && event.detail && event.detail.variant;
    if (!variant) return;

    var form = (event.target && event.target.tagName === "FORM")
      ? event.target
      : (event.detail.formId ? document.getElementById(event.detail.formId) : null)
      || (event.target && event.target.closest ? event.target.closest("form") : null);

    var scope = form || document;
    var buttons = scope.querySelectorAll("[data-cst-buy-now-button]");

    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (variant.id) btn.setAttribute("data-variant-id", normalizeVariantId(variant.id));
      if (variant.title) btn.setAttribute("data-variant-title", String(variant.title));
      if (variant.price) btn.setAttribute("data-price-cents", String(variant.price));

      var imgSrc = (variant.featured_image && (variant.featured_image.src || variant.featured_image.url))
        || (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src)
        || "";
      if (imgSrc) btn.setAttribute("data-product-image", normalizeImageUrl(imgSrc));

      if (variant.available === false) {
        btn.style.display = "none";
        btn.setAttribute("aria-disabled", "true");
      } else {
        btn.style.display = "";
        btn.removeAttribute("aria-disabled");
      }
    }
  }

  document.addEventListener("variant:changed", onVariantChange);
  document.addEventListener("variant:change", onVariantChange);

  document.addEventListener("change", function (event) {
    if (event.target && event.target.closest && event.target.closest("form")) {
      requestAnimationFrame(function () {
        syncAllButtons(event.target.closest("form"));
      });
    }
  });

  document.addEventListener("shopify:section:load", function (event) {
    syncAllButtons(event.target || document);
  });

  document.addEventListener("product:rerender", function (event) {
    syncAllButtons(event.target || document);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      syncAllButtons();
    });
  } else {
    syncAllButtons();
  }
})();


